import { useParams } from "react-router-dom";
import ActivationGeneralConfig from "./StarlinkConfig/ActivationGeneralConfig";

const GeneralConfig = () => {
	const { id } = useParams();
	const canEdit = false;
	const canUpdateconfig = false;
	return (
		<div className="space-y-4">
			<ActivationGeneralConfig id={id} canEdit={canEdit} canUpdate={canUpdateconfig} />
		</div>
	);
};

export default GeneralConfig;
